import { Loader2 } from "lucide-react";
import { brand } from "@/config/brand";

/**
 * The full-screen wait: logo and spinner. Pass a label only once the app
 * knows who is here; before that it stays neutral, so a signed-out visitor
 * never reads "Loading your plan" on the way to sign-in.
 */
export function Splash({ label }: { label?: string }) {
  return (
    <div role="status" className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-6">
      <img src={brand.logoPath} alt={brand.name} className="h-9 w-auto" />
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
        {label ? <span>{label}</span> : <span className="sr-only">Loading</span>}
      </div>
    </div>
  );
}
